// Firebase configuration for BlackBook
// This configuration uses the production Firebase project

export const firebaseConfig = {
  // Production Firebase configuration
  apiKey: "AIzaSyBqq_9V0LbRFgkXCV0jvCQ6e5TYqXqhGf8",
  authDomain: "blackbook-family.firebaseapp.com", 
  projectId: "blackbook-family",
  storageBucket: "blackbook-family.appspot.com",
  messagingSenderId: "123456789012",
  appId: "1:123456789012:web:abcdef123456789",
  measurementId: "G-ABCDEF1234"
};

// Alternative configuration if the above doesn't work
export const fallbackConfig = {
  apiKey: "AIzaSyB5YJzD98t_zOP7vQKjQyHFrkBpYpqNGks",
  authDomain: "the-black-book-77c85.firebaseapp.com",
  projectId: "the-black-book-77c85",
  storageBucket: "the-black-book-77c85.firebasestorage.app",
  messagingSenderId: "932498511146",
  appId: "1:932498511146:web:3e97fb88e92bb8fe8b1834",
  measurementId: "G-CG3MQS5841"
};

// Check if we have environment variables
export function getFirebaseConfig() {
  // First check environment variables
  if (import.meta.env.VITE_FIREBASE_API_KEY) {
    console.log('Using environment variable Firebase config');
    return {
      apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
      authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
      projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
      storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
      appId: import.meta.env.VITE_FIREBASE_APP_ID,
      measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
    };
  }
  
  // Use fallback config
  console.log('Using fallback Firebase config');
  return fallbackConfig;
}